import React from 'react';

function splitCsvGB(val) {
  return (val || "").split(/[,;\n]/).map((s) => s.trim()).filter(Boolean);
}

function buildGrievancePeople(form) {
  const people = [];
  if (form.supervisor_name?.trim()) {
    people.push({ name: form.supervisor_name.trim(), role: "Supervisor", notes: "" });
  }
  splitCsvGB(form.other_people).forEach((p) =>
    people.push({ name: p, role: "", notes: "" })
  );
  return people;
}

function inferGrievanceIssueType(form) {
  const haystack = [
    form.grievance_title, form.issue_summary, form.what_happened,
    form.safety_concerns, form.contract_concerns,
    ...(form.possible_issue_areas || []),
  ].join(" ").toLowerCase();
  if (/ppe|safety|arc flash|hazard|unsafe|lockout|tagout/.test(haystack)) return "safety_concern";
  if (/weingarten|steward|investigat|hr meeting/.test(haystack)) return "weingarten_violation";
  if (/overtime|mandatory|ot list|bypass/.test(haystack)) return "overtime_dispute";
  if (/shift|schedule|days off|notice/.test(haystack)) return "schedule_dispute";
  if (/writ(ten|e) up|discipline|suspended|termination|warning/.test(haystack)) return "discipline_investigation";
  if (/senior/.test(haystack)) return "seniority_dispute";
  if (/pay|wage|rate|differential/.test(haystack)) return "pay_grievance";
  if (/harass|bully|retaliat/.test(haystack)) return "harassment";
  return "other";
}

/* ─── Review helpers ─── */
function ReviewSection({ title, icon: Icon, accentColor, children }) {
  return (
    <div className="gb-review-block">
      <div className="gb-review-header">
        {Icon && <Icon size={15} style={{ color: accentColor || "var(--color-accent)" }} />}
        <h3>{title}</h3>
      </div>
      <div className="gb-review-body">{children}</div>
    </div>
  );
}

function ReviewRow({ label, value }) {
  if (!value) return null;
  return (
    <div className="gb-review-row">
      <span className="gb-review-label">{label}</span>
      <span className="gb-review-value">{value}</span>
    </div>
  );
}

function ReviewList({ items, ordered, emptyText }) {
  if (!items || items.length === 0) return <p className="gb-review-empty">{emptyText}</p>;
  const Tag = ordered ? "ol" : "ul";
  return <Tag className="gb-review-list">{items.map((item, i) => <li key={i}>{item}</li>)}</Tag>;
}

export {
  splitCsvGB, buildGrievancePeople, inferGrievanceIssueType,
  ReviewSection, ReviewRow, ReviewList,
};
